import { cn } from '@/lib/utils'

import { Skeleton, useBannerSliderVariants } from '../../../Theme'

import type { BannerSkeletonProps } from '../../types'

/**
 * BannerSkeleton - Loading state for banner slider
 *
 * Features:
 * - Uses Skeleton UI component from components/ui
 * - Uses bannerSkeletonVariants from CVA config for dimensions
 * - Consistent animation with design system
 *
 * @example
 * <BannerSkeleton />
 */
export function BannerSkeleton({ className }: BannerSkeletonProps) {
  const { bannerSectionVariants, bannerSkeletonVariants } = useBannerSliderVariants()

  return (
    <section className={bannerSectionVariants()}>
      <Skeleton className={cn(bannerSkeletonVariants(), 'w-full', className)} />
    </section>
  )
}
